import SlsUsuarioClient from '@/api/SistemaDKP/Usuario/sis-usuario.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSUsuarioService {
  constructor() {
    this.client = new SlsUsuarioClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os usuario');
    }
  }

  async findByTipoUsuario(usuariotipoid) {
    try {
      const { data } = await this.client.index(usuariotipoid);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os usuario');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar usuario');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar usuario');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar usuario');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.client.destroy(body);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar usuario');
    }
  }
}
